<template>
    <div class="video-detail">
        <CommonHeader></CommonHeader>

        <div class="video-detail-content">
            <div>
                <!-- <img src="@/static/imgs/my.jpeg" alt="" /> -->
                <img :src="courseInfo.cover" alt="" />
            </div>
            <div>
                <p class="font16">{{ courseInfo.title }}</p>
                <p class="font12 rac">
                    <span
                        v-if="courseInfo.is_buy == 1"
                        class="colord61"
                        style="color: #008eff !important"
                        >已购买</span
                    >
                    <span
                        v-else-if="Number(courseInfo.price) != 0"
                        class="colord61"
                        style="color: #008eff !important"
                        >￥{{ courseInfo.price }}</span
                    >
                    <span
                        v-else
                        class="colord61"
                        style="color: #008eff !important"
                        >免费</span
                    >
                    <span class="colorada"
                        >报名： {{ courseInfo.buy_times }}</span
                    >
                </p>
            </div>

            <!-- <div class="rac">
          <div class="hasIcon rc">
          <div class="ccc">
              <span class="iconfont icon-dianzan_active-copy-copy font18"></span>
          </div>
          <span class="font18">推荐模拟考试</span>
          </div>
          <div class="toSee font14" @click="toSee">点击查看</div>
      </div> -->

            <van-tabs v-model="active" title-active-color="#246FDD" animated>
                <van-tab title="课程介绍">
                    <div class="font14 video-detail-instroduce">
                        {{ courseInfo.introduction }}
                    </div>
                </van-tab>
                <van-tab title="课程目录">
                    <ul class="veido-detail-page font14">
                        <li
                            v-for="item in courses"
                            :key="item.id"
                            @click="toPaly(item, item.content, item.type)"
                        >
                            <van-tag
                                color="#bcbcbc"
                                plain
                                style="background-color: transparent; margin-right: 4px;"
                                >{{ item.type == 1 ? "录播" : "文档" }}</van-tag
                            >
                            {{ item.title }}
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>

        <div
            v-if="!(Number(courseInfo.price) == 0 || courseInfo.is_buy == 1)"
            class="video-detail-buy font16"
            @click="toBuy"
        >
            订购课程
        </div>
    </div>
</template>

<script>
import CommonHeader from "@/mobile/components/common-head";
export default {
    components: {
        CommonHeader,
    },
    data() {
        return {
            active: 0,
            courseInfo: [],
            courses: [],
        };
    },
    created() {
        let courseId = this.$route.query.id;
        this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0,
        });
        this.$get("/index/Videoedu/detail", {
            video_edu_id: courseId,
        }).then((res) => {
            this.$toast.clear();
            if (res.code == 200) {
                this.courseInfo = res.data.video_edu;
                this.courses = res.data.list.sort((x, y) => x.sort - y.sort);
            }
        });
    },
    methods: {
        toPaly(item, url, type) {
            if (
                !(
                    Number(this.courseInfo.price) == 0 ||
                    this.courseInfo.is_buy == 1
                ) &&
                type == 1
            ) {
                this.$toast("请先订购课程");
                return false;
            }
            if (type == 1) {
                if (navigator.userAgent.indexOf("UCBrowser") >= 0) {
                    this.$toast("请在微信中打开");
                } else {
                    this.$router.push({
                        path: "/playvideo",
                        query: {
                            content: encodeURIComponent(
                                JSON.stringify({
                                    score_time: item.score_time,
                                    show_time: item.show_time,
                                    id: item.id,
                                    url: item.content,
                                })
                            ),
                        },
                    });
                }
            } else {
                this.$router.push({
                    name: "Reader",
                    params: {
                        url: url,
                    },
                });
            }
        },
        toBuy() {
            if (this.$store.state.app.token) {
                this.$router.push({
                    path: "/index/buy",
                    query: {
                        id: this.courseInfo.id,
                        type: 5,
                    },
                });
            } else {
                this.$router.push("/login");
            }
        },
    },
};
</script>

<style lang="less">
.video-detail {
    height: 100vh;
    .video-detail-content {
        position: relative;
        top: 40px;
        width: 100%;
        box-sizing: border-box;
        height: calc(100% - 74px);
        overflow: scroll;

        & > div {
            &:first-child {
                width: 100%;
                height: 160px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            &:nth-child(2) {
                width: 100%;
                padding: 15px 10px;
                box-sizing: border-box;
                & > p {
                    margin-bottom: 10px;
                }
            }

            &:nth-child(3) {
                margin: 0 10px;
                width: auto;
                height: 70px;
                border-radius: 10px;
                border: none;
                box-sizing: border-box;
                // padding: 0 15px;
                // background-image: linear-gradient(to right, #ffedc7, #f0d6a5);

                .hasIcon {
                    width: 50%;
                    & > div {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        color: #ecb234;
                        background: #fce2b0;
                        margin-right: 4px;
                    }
                }

                .toSee {
                    width: 90px;
                    height: 30px;
                    border-radius: 14px;
                    color: white;
                    text-align: center;
                    line-height: 30px;
                    background-image: linear-gradient(
                        to right,
                        #ffca34,
                        #ff6801
                    );
                }
            }

            &:nth-child(4) {
                height: 8px;
                background: #f6f7fb;
                margin: 10px 10px;
            }

            .video-detail-instroduce {
                box-sizing: border-box;
                padding: 20px;
            }

            .veido-detail-page {
                & > li {
                    padding-left: 20px;
                    height: 40px;
                    line-height: 60px;
                }
            }
        }
    }

    .video-detail-buy {
        position: fixed;
        width: 96%;
        color: white;
        background: #008eff;
        height: 40px;
        text-align: center;
        bottom: 0;
        left: 2%;
        line-height: 40px;
    }

    .van-tabs__wrap {
        border-bottom: 1px solid #ddd;
    }
    .van-tabs__line {
        background-color: #246fdd !important;
    }
}
</style>
